import { Box, BoxProps } from "@mui/material";
import PageContentBox from "@/src/components/journal-site/common/page-content/mui-custom/page-content-box/page-content-box";
import { PropsWithChildren } from "react";

const PageContent = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
  return (
    <Box style={{ zIndex: 10 }} {...props}>
      <PageContentBox>{children}</PageContentBox>
    </Box>
  );
};

export default PageContent;
